<template>
  <div
    role="group"
    data-slot="field"
    :data-orientation="orientation"
    :class="cn(fieldVariants({ orientation }), props.class)"
  >
    <slot />
  </div>
</template>

<script setup>
defineOptions({ name: 'UiField' });
import { cn } from '@/shared/utilities/classes';
import { fieldVariants } from '.';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    default: undefined,
    required: false,
    skipCheck: true,
  },
  orientation: { type: null, default: undefined, required: false },
});
</script>
